import { ViewingTypeCode } from 'Shared/types';

export enum PostViewingTypeCode {
  NBLOG_BLOG = ViewingTypeCode.NBLOG_BLOG,
  NBLOG_BLOG_LITE = ViewingTypeCode.NBLOG_BLOG_LITE,
}
